import CheckBoxInput from "../../../../utils/CheckBoxInput";
import React from "react";
import { Controller } from "react-hook-form";

export const userPayCheckboxForm = (errors: any, control: any) => [
  <Controller
    name={"acceptEAktywni"}
    control={control}
    rules={{ required: true }}
    render={({ field }) => (
      <CheckBoxInput
        name={"acceptEAktywni"}
        field={field}
        title={
          <span>
            *Akceptuję {""}
            <a href={"https://eaktywni.pl/polityka-prywatnosci/"}>regulamin</a>
            {""} serwisu eAktywni.pl.
          </span>
        }
        errors={errors}
      />
    )}
  />,
  <Controller
    name={"acceptPrivacyPolicy"}
    control={control}
    rules={{ required: true }}
    render={({ field }) => (
      <CheckBoxInput
        name={"acceptPrivacyPolicy"}
        field={field}
        title={
          <span>
            *Akceptuję {""}
            <a href={"https://eaktywni.pl/polityka-prywatnosci/"}>politykę prywatności.</a>
          </span>
        }
        errors={errors}
      />
    )}
  />,
  <Controller
    name={"acceptStatute"}
    control={control}
    rules={{ required: true }}
    render={({ field }) => (
      <CheckBoxInput
        name={"acceptStatute"}
        field={field}
        title={
          <span>
            *Akceptuję {""}
            <a href="https://panel.eaktywni.pl/img/1222/regulamin_int_ciezkowice.pdf"  target="blank">regulamin</a> serwisu i <a href="https://panel.eaktywni.pl/img/1222/polityka_mcee.pdf"  target="blank">politykę prywatności</a> sklepu
            internetowego.
          </span>
        }
        errors={errors}
      />
    )}
  />,
];
